// Delivery item types
export const DELIVERY = "delivery";
export const COLLECTION = "collection";
export const RECYCLING = "recycling";
export const AFTER_SALES = "after_sales";
